import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMapMui = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_20_116)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M7.53842 17.4066H5.20162L2.46002 23.54H22.0867L19.339 17.4066H16.9347M6.62456 12.5736L12.1752 20.5408L17.7259 12.5736C18.5968 11.4144 19.112 9.96692 19.112 8.40292C19.1182 3.50852 14.052 -0.208285 8.87549 2.22665C7.59976 2.82772 6.56936 3.87038 5.98056 5.15225C4.70482 7.91225 5.17096 10.6354 6.62456 12.5736V12.5736ZM14.1318 5.50185C14.5243 5.72265 14.8494 6.05385 15.0763 6.44638C16.0147 8.09012 15.6651 9.74612 14.6715 10.7888C13.6472 11.8621 11.9299 12.273 10.231 11.3101C9.83842 11.0832 9.50109 10.752 9.28029 10.3594C7.38509 7.02292 10.8014 3.60665 14.1318 5.50185V5.50185Z",
				stroke: "currentColor",
				strokeWidth: 1.2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_20_116",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgMapMui);
export { ForwardRef as ReactComponent };
